import { render, staticRenderFns } from "./admin-modal-reservation.vue?vue&type=template&id=15106901&scoped=true"
import script from "./admin-modal-reservation.vue?vue&type=script&lang=ts"
export * from "./admin-modal-reservation.vue?vue&type=script&lang=ts"
import style0 from "./admin-modal-reservation.vue?vue&type=style&index=0&id=15106901&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15106901",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\dev\\eatself\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('15106901')) {
      api.createRecord('15106901', component.options)
    } else {
      api.reload('15106901', component.options)
    }
    module.hot.accept("./admin-modal-reservation.vue?vue&type=template&id=15106901&scoped=true", function () {
      api.rerender('15106901', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "admin-components/admin-modal-reservation.vue"
export default component.exports